import React from "react";
import { Form, Switch, Card, Tag, Divider, Statistic } from "antd";
import {
  RiStarFill,
  RiEyeLine,
  RiCheckLine,
  RiThumbUpLine,
} from "react-icons/ri";

const RightCol = ({ values, setValues }) => {
  return (
    <div style={{ paddingLeft: "16px" }}>
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        layout="horizontal"
        size="middle"
      >
        {/* Publishing Section */}
        <Divider orientation="left" style={{ marginTop: 0 }}>
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Publishing</span>
        </Divider>

        {/* Publish Toggle */}
        <Form.Item label="Publish">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Switch
              checked={values.publish}
              onChange={(checked) =>
                setValues({
                  ...values,
                  publish: checked,
                })
              }
            />
            <span style={{ fontSize: "12px", color: "#666" }}>
              {values.publish ? "Visible to users" : "Hidden from users"}
            </span>
          </div>
        </Form.Item>

        {/* Featured Toggle */}
        <Form.Item label="Featured">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Switch
              checked={values.featured}
              onChange={(checked) =>
                setValues({
                  ...values,
                  featured: checked,
                })
              }
            />
            <span style={{ fontSize: "12px", color: "#666" }}>
              {values.featured ? "Shown in featured section" : "Not featured"}
            </span>
          </div>
        </Form.Item>

        {/* Preview Section */}
        <Divider orientation="left">
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Preview</span>
        </Divider>
      </Form>

      {/* Preview Card */}
      <Card
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Header with color */}
        <div
          style={{
            background: `linear-gradient(135deg, ${values.color || "#6366f1"} 0%, ${values.color || "#6366f1"}dd 100%)`,
            padding: "20px 16px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {values.image ? (
            <img
              src={values.image}
              alt="copilot"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                objectFit: "cover",
                border: "2px solid rgba(255,255,255,0.3)",
              }}
            />
          ) : (
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                backgroundColor: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
              }}
            >
              {values.icon || "📊"}
            </div>
          )}
          <div>
            <h3
              style={{
                margin: 0,
                color: "#fff",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {values.name || "Copilot Name"}
            </h3>
            <p
              style={{
                margin: 0,
                color: "rgba(255,255,255,0.85)",
                fontSize: "12px",
                marginTop: "2px",
              }}
            >
              {values.shortDescription || "Short description goes here"}
            </p>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "16px" }}>
          {/* Tags */}
          {values.tags?.length > 0 && (
            <div style={{ marginBottom: "12px" }}>
              {values.tags.slice(0, 4).map((tag) => (
                <Tag key={tag} style={{ marginBottom: "4px" }}>
                  {tag}
                </Tag>
              ))}
              {values.tags.length > 4 && (
                <Tag>+{values.tags.length - 4}</Tag>
              )}
            </div>
          )}

          {/* Description Preview */}
          <p
            style={{
              color: "#666",
              fontSize: "13px",
              margin: 0,
              lineHeight: 1.5,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {values.description || "Description will appear here..."}
          </p>

          {/* Status indicators */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginTop: "16px",
              paddingTop: "12px",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: values.publish ? "#52c41a" : "#999",
              }}
            >
              <RiEyeLine size={14} />
              <span style={{ fontSize: "11px" }}>
                {values.publish ? "Published" : "Draft"}
              </span>
            </div>
            {values.featured && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#faad14",
                }}
              >
                <RiStarFill size={14} />
                <span style={{ fontSize: "11px" }}>Featured</span>
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: "#666",
              }}
            >
              <span style={{ fontSize: "11px" }}>
                Order: {values.order || 0}
              </span>
            </div>
          </div>
        </div>
      </Card>

      {/* Stats Section (for update modal) */}
      {values._id && (
        <>
          <Divider orientation="left" style={{ marginTop: "24px" }}>
            <span style={{ fontSize: "14px", fontWeight: 600 }}>Statistics</span>
          </Divider>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "12px",
            }}
          >
            <Card size="small" style={{ textAlign: "center" }}>
              <Statistic
                title="Times Used"
                value={values.used || 0}
                valueStyle={{ fontSize: "20px" }}
              />
            </Card>
            <Card size="small" style={{ textAlign: "center" }}>
              <Statistic
                title="Likes"
                value={values.likes?.length || 0}
                prefix={<RiThumbUpLine size={16} />}
                valueStyle={{ fontSize: "20px" }}
              />
            </Card>
          </div>
        </>
      )}

      {/* Suggested Questions Preview */}
      {values.suggestedQuestions?.filter((q) => q).length > 0 && (
        <>
          <Divider orientation="left" style={{ marginTop: "24px" }}>
            <span style={{ fontSize: "14px", fontWeight: 600 }}>
              Quick Prompts
            </span>
          </Divider>

          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {values.suggestedQuestions
              ?.filter((q) => q)
              .map((question, index) => (
                <div
                  key={index}
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    fontSize: "12px",
                    color: "#333",
                    border: "1px solid #e8e8e8",
                  }}
                >
                  {question}
                </div>
              ))}
          </div>
        </>
      )}

      {/* Welcome Message Preview */}
      {values.welcomeMessage && (
        <>
          <Divider orientation="left" style={{ marginTop: "24px" }}>
            <span style={{ fontSize: "14px", fontWeight: 600 }}>
              Welcome Message
            </span>
          </Divider>

          <div
            style={{
              padding: "12px 16px",
              backgroundColor: values.color || "#6366f1",
              borderRadius: "12px",
              color: "#fff",
              fontSize: "13px",
              lineHeight: 1.5,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px",
              }}
            >
              <span style={{ fontSize: "16px" }}>{values.icon || "📊"}</span>
              <span style={{ fontWeight: 500 }}>{values.name || "Copilot"}</span>
            </div>
            {values.welcomeMessage}
          </div>
        </>
      )}
    </div>
  );
};

export default RightCol;
